import { Component, EventEmitter, Output } from '@angular/core';
import { CommonService } from '@core/services/common-service/common.service';
import { environment } from '@environments/environment';
import { GlobalConstants } from '@environments/global-Variables';
import { OnBoardingEmployeeComponent } from '@modules/people/on-boarding-employee/on-boarding-employee.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-sidebar-navigation',
  templateUrl: './sidebar-navigation.component.html',
  styleUrls: ['./sidebar-navigation.component.scss']
})
export class SidebarNavigationComponent {
  userRole: any;
  BusinessPartner: string = "";
  SystemAdmin: string = "";
  buildNumber: string = "";
  countData: any;
  countDataSubscription!: Subscription;
  personalDetailsSubscription!: Subscription;
  nonEmployeeFlag: boolean = false;
  bsModalRef!: BsModalRef;
  globalConstants = GlobalConstants

  constructor(
    private commonService: CommonService,
    private modalService: BsModalService,
  ) {
    this.userRole = localStorage.getItem(GlobalConstants?.USER_ROLE_KEY)
    this.userRole = JSON.parse(window.atob(this.userRole));
    if (this.userRole?.includes(this.globalConstants.ROLE_NON_EMPLOYEE)) {
      this.nonEmployeeFlag = true;
    }
    this.BusinessPartner = GlobalConstants.BUSINESS_PARTNER;
    this.SystemAdmin = GlobalConstants.SYSTEM_ADMIN;
    if (environment.buildNumber == "#{buildNumber}#") {
      this.buildNumber = "local";
    }
    else {
      this.buildNumber = environment.buildNumber;
    }

    this.commonService.countChangeItem$.subscribe(
      (countChange: any) => {
        if (countChange) {
          this.getCounts();
          this.commonService.countChangeItemHandler(false);
        }
      });
  }
  @Output() menuToggle = new EventEmitter<boolean>();

  collapseMenu: boolean = false;
  ngOnInit() {
    this.getCounts();
    this.getPersonData();
    this.onWindowSizeCloseSideMenu();
  }

  /** Get count for side navigation bar count update */
  getCounts() {
    this.countDataSubscription = this.commonService.getCounts('').subscribe((data: any) => {
      this.countData = data;
    });
  }

  /** Getting person details data */
  getPersonData() {
    let personReqParam = {
      personId: 0
    }
    this.personalDetailsSubscription = this.commonService.getPersonalDetails(personReqParam).subscribe((personDetailData: any) => {
      this.commonService.setPersonData(personDetailData);
    })
  }
  /** closing menu based on screen size */
  onWindowSizeCloseSideMenu() {
    if (window.innerWidth <= 1023) {
      this.collapseMenu = true;
    }
  }

  /** Collapse menu based on small screen size */
  smallDeviceCollapseMenu() {
    if (window.innerWidth <= 1023) {
      this.collapseMenu = !this.collapseMenu;
      this.menuToggle.emit();
    }
  }

  /** Side navigation menu toggle functionality */
  sidenavCollapseMenu() {
    this.collapseMenu = !this.collapseMenu;
    this.menuToggle.emit();
  }

  /** To display the On-Boarding Popup */
  openOnBoardModal() {
    const modalData: any = {
      data: ''
    }
    this.bsModalRef = this.modalService.show(OnBoardingEmployeeComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
    this.bsModalRef.onHide?.subscribe((res) => {

    })
  }
}

